import React, { useEffect, useState } from "react";
import classes from "./MyGames.module.css";
import { motion } from "framer-motion";
import { FaArrowLeft, FaChevronRight, FaPlay } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { fetchAndroidGamesApi, fetchGamesApi } from "../http/http";

import { Swiper, SwiperSlide } from "swiper/react";
import {
    Autoplay,
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Keyboard,
    EffectCoverflow,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useTranslation } from "react-i18next";

const MyGames = () => {
    const navigate = useNavigate();

    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);
    const [myGamesData, setMyGamesData] = useState(null);

    const selectedLanguageId = Number(
        useSelector((state) => state?.persisted?.languageSlice?.language ?? 1),
    );

    const fetchMyGames = async (language) => {
        try {
            setLoading(true);

            const response = await fetchGamesApi(language);
            const response2 = await fetchAndroidGamesApi(language);

            const allGamesData = response?.data?.games || [];

            setMyGamesData(allGamesData);
        } catch (error) {
            console.log(error, "my games error--");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMyGames(selectedLanguageId);
    }, [selectedLanguageId]);

    console.log(myGamesData, 'mygd');

    const renderSkeletonCards = (count, firstLarge = false) => {
        return Array.from({ length: count }).map((_, index) => {
            const isLarge = firstLarge && index === 0;

            return (
                <div
                    key={`skeleton-${firstLarge ? "top" : "bottom"}-${index}`}
                    className={`${classes.game_card} ${isLarge ? classes.large_card : classes.small_card
                        } ${classes.skeletonCard}`}
                >
                    <div className={classes.skeletonImage}></div>

                    <div className={classes.skeletonContent}>
                        <div className={classes.skeletonMetaRow}>
                            <span className={classes.skeletonMeta}></span>
                            <span className={classes.skeletonChip}></span>
                        </div>

                        <span
                            className={`${classes.skeletonTitle} ${isLarge
                                ? classes.skeletonTitleLarge
                                : classes.skeletonTitleSmall
                                }`}
                        ></span>

                        <span
                            className={`${classes.skeletonTitle} ${isLarge
                                ? classes.skeletonTitleMedium
                                : classes.skeletonTitleTiny
                                }`}
                        ></span>
                    </div>
                </div>
            );
        });
    };

    return (
        <main className={classes.main}>
            <div className={classes.bgGlowOne}></div>
            <div className={classes.bgGlowTwo}></div>
            <div className={classes.bgGrid}></div>

            <section className={classes.wrapper}>
                <motion.div
                    className={classes.topBar}
                    initial={{ opacity: 0, y: -18 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <motion.button
                        className={classes.backBtn}
                        onClick={() => navigate(-1)}
                        whileHover={{ x: -3, scale: 1.04 }}
                        whileTap={{ scale: 0.96 }}
                    >
                        <FaArrowLeft />
                    </motion.button>

                    <div className={classes.headerContent}>
                        <p className={classes.headerMiniText}>{t("133")}</p>
                        <h1 className={classes.pageTitle}>{t("134")}</h1>

                        <div className={classes.headerBottomRow}>
                            <p className={classes.pageSubTitle}>
                                {t("135")}
                            </p>

                            <div className={classes.headerBadge}>{t("136")}</div>
                        </div>
                    </div>
                </motion.div>

                {loading ? (
                    <>
                        <section className={classes.games_section_main}>
                            <div className={classes.section_glow_left} />
                            <div className={classes.section_glow_right} />

                            <section className={classes.games_section}>
                                {renderSkeletonCards(5, true)}
                            </section>
                        </section>
                    </>
                ) : (
                    <>
                        <section
                            className={
                                classes.games_carousel
                            }
                        >

                            <div className={classes.games_carousel_header}>
                                <div className={classes.section_heading_top}>
                                    <span className={classes.section_badge}>
                                       {t("137")}
                                    </span>
                                    <span className={classes.section_line}></span>
                                </div>
                            </div>

                            <div className={classes.games_carousel_sub_section}>
                                <Swiper
                                    modules={[Autoplay, Navigation, Keyboard]}
                                    slidesPerGroupSkip={1}
                                    grabCursor={true}
                                    keyboard={{
                                        enabled: true,
                                    }}
                                    loop
                                    spaceBetween={8}
                                    // slidesPerView={3}
                                    slidesPerView={"auto"}
                                    autoplay={{
                                        delay: 5000,
                                        disableOnInteraction: false,
                                    }}
                                    // navigation={{
                                    //     prevEl: ".custom-swiper-prev",
                                    //     nextEl: ".custom-swiper-next",
                                    // }}
                                    onSwiper={(swiper) => null}
                                    onSlideChange={() => null}
                                >
                                    {myGamesData?.slice(0, 10).map((g, index) => (
                                        <SwiperSlide
                                            className={classes.game_carousel_container_slide_2}
                                            key={index}
                                        // onClick={() => handleNavigate(g?.game_url)}
                                        >
                                            <div className={classes.game_carousel_container_2}>
                                                <div className={classes.game_carousel_image_2}>
                                                    <img
                                                        src={g?.game_banner}
                                                        alt={g?.game_name}
                                                        loading="lazy"
                                                        className={classes.game_carousel_img_2}
                                                    />
                                                </div>
                                                <p className={classes.game_carousel_title_2}>
                                                    {g?.game_name}
                                                </p>
                                                <button
                                                    type="button"
                                                    className={classes.hero_play_button}
                                                    onClick={() =>
                                                        navigate("/game", {
                                                            state: {
                                                                game: g,
                                                            },
                                                        })
                                                    }
                                                >
                                                    {t("65")}
                                                </button>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </section>


                        <section
                            className={
                                classes.games_carousel
                            }
                        >

                            <div className={classes.games_carousel_header}>
                                <div className={classes.section_heading_top}>
                                    <span className={classes.section_badge}>
                                        {t("138")}
                                    </span>
                                    <span className={classes.section_line}></span>
                                </div>
                            </div>

                            <div className={classes.games_carousel_sub_section}>
                                <Swiper
                                    modules={[Autoplay, Navigation, Keyboard]}
                                    slidesPerGroupSkip={1}
                                    grabCursor={true}
                                    keyboard={{
                                        enabled: true,
                                    }}
                                    loop
                                    spaceBetween={8}
                                    // slidesPerView={3}
                                    slidesPerView={"auto"}
                                    autoplay={{
                                        delay: 5000,
                                        disableOnInteraction: false,
                                    }}
                                    // navigation={{
                                    //     prevEl: ".custom-swiper-prev",
                                    //     nextEl: ".custom-swiper-next",
                                    // }}
                                    onSwiper={(swiper) => null}
                                    onSlideChange={() => null}
                                >
                                    {myGamesData?.slice(0, 10).map((g, index) => (
                                        <SwiperSlide
                                            className={classes.game_carousel_container_slide_2}
                                            key={index}
                                        // onClick={() => handleNavigate(g?.game_url)}
                                        >
                                            <div className={classes.game_carousel_container_2}>
                                                <div className={classes.game_carousel_image_2}>
                                                    <img
                                                        src={g?.game_banner}
                                                        alt={g?.game_name}
                                                        loading="lazy"
                                                        className={classes.game_carousel_img_2}
                                                    />
                                                </div>
                                                <p className={classes.game_carousel_title_2}>
                                                    {g?.game_name}
                                                </p>
                                                <button
                                                    type="button"
                                                    className={classes.hero_play_button}
                                                    onClick={() =>
                                                        navigate("/game", {
                                                            state: {
                                                                game: g,
                                                            },
                                                        })
                                                    }
                                                >
                                                    {t("65")}
                                                </button>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </section>
                    </>
                )
                }



            </section>
        </main>
    );
};

export default MyGames;